import { useContext, useEffect } from 'react'

import { Layout } from 'antd'
import styled from 'styled-components'
import { Worker } from 'twilio-taskrouter'

import { MeetingComponent, MeetingHistory } from '../components'
import { useAosToken, useTwilioTokenApi } from '../hooks'
import { TwilioWorkerContext } from '../providers'

const StyledContent = styled(Layout.Content)`
  display: flex;
  gap: 30px;
  padding: 20px;
  box-sizing: border-box;
  height: 100%;
`

export const Call: React.FC = () => {
  const aosToken = useAosToken()
  const { data: twilioData } = useTwilioTokenApi({
    aosToken,
  })
  const { setWorker } = useContext(TwilioWorkerContext)

  useEffect(() => {
    if (twilioData?.twilio_access_token) {
      setWorker(new Worker(twilioData.twilio_access_token))
    }
  }, [twilioData, setWorker])

  return (
    <StyledContent>
      <MeetingHistory />
      <MeetingComponent />
    </StyledContent>
  )
}
